import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { GeofencingMgtService } from '../../services/geofencing-mgt.service';

@Component({
  selector: 'app-geofence-logs',
  templateUrl: './geofence-logs.component.html',
  styleUrls: ['./geofence-logs.component.scss'],
})
export class GeofenceLogsComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  success: any;
  error: any;
  logs: any[] = [];
  totalItems: number;
  constructor(private geofenceSvc: GeofencingMgtService) {
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    this.getPage(1);
    this.totalItems = this.logs.length;
  }
  headers = [
    {
      field: 'username',
      label: 'Username',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'description',
      label: 'Description',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'location',
      label: 'Location',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];
  headerFilters = [];

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'description',
        op: 'cn',
        data: '',
      },
      {
        field: 'username',
        op: 'cn',
        data: '',
      },
      {
        field: 'location',
        op: 'cn',
        data: '',
      },
    ],
  };

  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });

    this.getPage(1);
  }
  advancedSearch(e) {
    if (e) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(e);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;

    this.getPage(1);
  }

  ngOnInit(): void {}
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.geofenceSvc.getGeofenceLogs({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.totalItems = +res.records;
        this.logs = res.rows;
        this.currentPage = +res.page;
        this.rows = this.filter.rows;
      },
      (error) => {
        this.pending = false;
        this.error = error.error ? error.error : error;
      }
    );
  }

  parse(item) {
    return JSON.parse(item);
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'description',
          op: 'cn',
          data: '',
        },
        {
          field: 'username',
          op: 'cn',
          data: '',
        },
        {
          field: 'location',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.sidx = 'desc';
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }
}
